// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__GZv5s","images":"Banner_images__cKRoW"};